import React from 'react';

import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Container = styled(Chip)`
    margin-left: 0.5rem;
`;

export interface DraftTextProps {}

const DraftChip: React.FC<DraftTextProps> = () => {
    const { t } = useTranslation('admin_settings');

    return <Container label={t('draft')} size="small" />;
};

export default DraftChip;
